import { css } from "lit";
import { ComponentState } from "@omegagrid/core";
import { Application } from "../container/application";
import { AppComponent } from "../component";

const headStyle = css`
	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}

	.head {
		min-height: 41px;
		flex: 0;
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.head > * {
		flex: 1;
		text-align: center;
		border-right: 1px solid var(--og-bucket-border-color);
		height: 100%;
	}

	.head > *:last-child {
		border-right: none;
	}
`;

const controlStyle = css`
	.controls {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		border-bottom: 1px solid var(--og-bucket-border-color);
		flex: 0 0 25px;
	}

	.controls > * {
		height: 100%;
	}

	.controls > og-button {
		width: 25px;
	}
`;

export abstract class BaseSidebar<TApp extends Application = Application, TState extends ComponentState = ComponentState> extends AppComponent<TApp, TState> {

	static styles = [css`
		* {
			box-sizing: border-box;
		}
	`, headStyle, controlStyle];

}
